import {
  AlertDialog,
  Icon,
  InputDropdown,
  Section,
  Text,
  useToast,
} from '@vallourec-ui/vallourec-ui'
import React, { useEffect, useState } from 'react'

import * as XLSX from 'xlsx'

import { useTranslation } from 'react-i18next'

import { isAxiosError } from 'axios'

import { generateReport as generateReportPost } from '@/api/post'

import { useGenerateReport } from '@/stores/GenerateReportStore'

import DifferentHeaderModal from '../DifferentHeaderModal'
import {
  ButtonContainer,
  Row,
  SearchBarContainer,
  StyledButton,
  StyledInputLabel,
  StyledTextButton,
  StyledText,
} from './style'
import { ButtonsContainer } from '@/components/ImageCard/style'
import TextFieldInput from '@/components/TextFieldInput'
import { useApp } from '@/stores/AppStore'
import { SITES } from '@/utils/constants'
import { downloadBase64, getDateNow, getDateTimeNow } from '@/utils/utils'

const DataToEditSection: React.FC = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const { setIsLoading, user, remark } = useApp()
  const {
    site,
    test,
    startDate,
    endDate,
    orderItem,
    typeInspections,
    types,
    clientHeader,
    setClientHeader,
    descriptionHeader,
    setDescriptionHeader,
    projectHeader,
    setProjectHeader,
    inspectionHeader,
    setInspectionHeader,
    pedidoItemHeader,
    setPedidoItemHeader,
    currentItem,
    testSelected,
    heatItems,
    processOrderItems,
    pqLotItems,
    resultItemsSelected,
    setResultItemsSelected,
    remark1,
    setRemark1,
    remark2,
    setRemark2,
    remark3,
    setRemark3,
    templateTest,
    completeHeaderItem,
    setCompleteHeaderItem,
    base64Graphics,
    generateNewReport,
  } = useGenerateReport()

  const [showConfirm, setShowConfirm] = useState(false)
  const [descriptionDocuments, setDescriptionDocuments] = useState('')
  const [differentHeaderModalOpen, setDifferentHeaderModalOpen] =
    useState(false)

  const [mapRemark1, setMapRemark1] = React.useState<string[]>([])
  const [mapRemark2, setMapRemark2] = React.useState<string[]>([])
  const [mapRemark3, setMapRemark3] = React.useState<string[]>([])

  useEffect(() => {
    const foundRemark = remark?.find((item) => item.type === testSelected?.type)

    setRemark1('')
    setRemark2('')
    setRemark3('')

    setMapRemark1(
      foundRemark?.remarks
        .filter((item) => item.line === '1')
        .map((item) => item.remark) ?? []
    )
    setMapRemark2(
      foundRemark?.remarks
        .filter((item) => item.line === '2')
        .map((item) => item.remark) ?? []
    )
    setMapRemark3(
      foundRemark?.remarks
        .filter((item) => item.line === '3')
        .map((item) => item.remark) ?? []
    )
  }, [testSelected])

  const validatePermissionReport = (
    optionGenerate: string,
    typeCode: string
  ) => {
    let hasPermission = false
    if (user && user.permissions) {
      switch (optionGenerate) {
        case 'generateReport':
          hasPermission =
            user.permissions[typeCode.toLowerCase()].includes('elaborate') ||
            user.permissions[typeCode.toLowerCase()].includes('view')
          break
        case 'sendApprovalReport':
          hasPermission =
            user.permissions[typeCode.toLowerCase()].includes('elaborate')
          break
        default:
          break
      }
    }
    return hasPermission
  }

  const validateItemsSelectedReportNaceD = () => {
    if (
      testSelected?.typeCode === 'corrosion' &&
      testSelected.id === 'nace_d' &&
      resultItemsSelected
    ) {
      let idEnsaio = ''
      resultItemsSelected.forEach((item) => {
        if ('id_ensaio' in item && item.id_ensaio) {
          if (idEnsaio === '') {
            idEnsaio = item.id_ensaio
          } else if (item.id_ensaio !== idEnsaio) {
            return true
          }
        }
      })
    }
    return false
  }

  const validateOneTestReport = () => {
    const allowOnlyOneTests = [
      'ctdo',
      'reeling',
      'collapse',
      'micro_cleanliness_d',
    ]
    const allowOnlyOneTestsLot = ['mpi']

    if (
      testSelected &&
      resultItemsSelected &&
      resultItemsSelected.length > 1 &&
      (allowOnlyOneTests.includes(testSelected.id) ||
        allowOnlyOneTestsLot.includes(testSelected.id))
    ) {
      if (allowOnlyOneTestsLot.includes(testSelected.id)) {
        const count: string[] = []
        resultItemsSelected.forEach((item) => {
          if ('lot_id' in item && !count.includes(item.lot_id)) {
            count.push(item.lot_id)
          }
        })
        if (count.length > 1) {
          setResultItemsSelected([])
          return true
        }
      } else {
        setResultItemsSelected([])
        return true
      }
    }

    return false
  }

  const canGenerate = async (optionGenerate = '', justGenerate = false) => {
    let valid = true
    const permissionReport = testSelected
      ? validatePermissionReport(optionGenerate, testSelected.typeCode)
      : false
    if (!permissionReport) {
      toast({
        title: 'Error',
        description: t('user.permission_not_action'),
        type: 'error',
      })
      valid = false
    } else {
      if (!justGenerate && (!user || !user.hasSignature)) {
        toast({
          title: 'Error',
          description: t('user.signature_not_exists'),
          type: 'error',
        })
        valid = false
      }
      if (!resultItemsSelected || !resultItemsSelected.length) {
        toast({
          title: 'Error',
          description: t('generateReport.dataToResult.select_test'),
          type: 'error',
        })
        valid = false
      }
      if (validateOneTestReport()) {
        toast({
          title: 'Error',
          description: t('generateReport.dataToResult.one_test'),
          type: 'error',
        })
        valid = false
      }
      if (validateItemsSelectedReportNaceD()) {
        toast({
          title: 'Error',
          description: t('generateReport.dataToResult.multiples_test'),
          type: 'error',
        })
        valid = false
      }
    }

    return valid
  }

  const isDifferentHeader = () => {
    const differenceItemsHeader = getDifferentHeader()
    return differenceItemsHeader.length > 1
  }

  const findItem = (test: any, differenceItemsHeader: any) => {
    const exist = differenceItemsHeader.find((edit: any) => {
      return (
        edit.desc_cliente === test.desc_cliente &&
        edit.descricao_mes === test.descricao_mes &&
        edit.project === test.project &&
        edit.inspection === test.inspection &&
        edit.pedido === test.pedido &&
        edit.item === test.item
      )
    })
    return !exist
  }

  // const completeHeaderItemApproval = (completeHeaderItem: any = {}) => {
  //   completeHeaderItem.remark1 = remark1
  //   completeHeaderItem.remark2 = remark2
  //   completeHeaderItem.remark3 = remark3

  //   completeHeaderItem.inspectorType = typeInspections
  //   completeHeaderItem.sampleType = types
  //   completeHeaderItem.orderProcess = processOrderItems

  //   completeHeaderItem.startDate = startDate
  //   completeHeaderItem.endDate = endDate

  //   completeHeaderItem.customerChange = clientHeader
  //   completeHeaderItem.descriptionChange = descriptionHeader
  //   completeHeaderItem.inspectionChange = inspectionHeader
  //   completeHeaderItem.project = project
  //   completeHeaderItem.projectChange = projectHeader
  //   completeHeaderItem.orderItemChange = orderItem

  //   if (currentItem && currentItem.tipo_cp) {
  //     completeHeaderItem.tipo_cp = currentItem.tipo_cp
  //   }
  //   if (currentItem && currentItem.l_zero_mes) {
  //     completeHeaderItem.l_zero_mes = currentItem.l_zero_mes
  //   }

  //   return completeHeaderItem
  // }

  useEffect(() => {
    if (currentItem) {
      setCompleteHeaderItem({
        remark1,
        remark2,
        remark3,
        inspectorType: typeInspections,
        sampleType: types,
        orderProcess: processOrderItems,
        pqLot: pqLotItems,
        startDate,
        endDate,
        customerChange: clientHeader,
        descriptionChange: descriptionHeader,
        inspectionChange: inspectionHeader,
        projectChange: projectHeader,
        orderItemChange: orderItem,
        ...('tipo_cp' in currentItem && currentItem.tipo_cp
          ? { tipo_cp: currentItem.tipo_cp }
          : {}),
        ...('l_zero_mes' in currentItem && currentItem.l_zero_mes
          ? { l_zero_mes: currentItem.l_zero_mes }
          : {}),
      })
    } else {
      setCompleteHeaderItem({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentItem,
    remark1,
    remark2,
    remark3,
    typeInspections,
    types,
    processOrderItems,
    startDate,
    endDate,
    clientHeader,
    descriptionHeader,
    inspectionHeader,
    projectHeader,
    orderItem,
  ])

  const generateReport = async (
    justGenerateValue = false,
    generateExcel = false
  ) => {
    const elaborationPosition = user?.userPosition ?? ' '
    const elaborationName = user?.userName ?? ' '

    if (
      testSelected &&
      currentItem &&
      completeHeaderItem &&
      resultItemsSelected &&
      user &&
      user.userPosition
    ) {
      try {
        const result = await generateReportPost({
          email: user.email,
          user: user.userName,
          position: user.userPosition,
          test: testSelected,
          generate: true,
          dateNow: getDateNow(),
          testName: test,
          selected: resultItemsSelected,
          remark1,
          remark2,
          remark3,
          site: SITES.find((s) => s.name === site),
          heat: heatItems,
          documents: [],
          currentDate: getDateTimeNow().en,
          // requirements: this.requirementsValue,
          elaboration: elaborationName,
          elaboration_position: elaborationPosition,
          ...(base64Graphics ? { base64Graphics } : {}),
          customFields: {
            completeHeaderItem,
            customer: clientHeader,
            description: descriptionHeader,
            inspection: inspectionHeader,
            project: projectHeader,
            orderItem: pedidoItemHeader,
            justGenerate: justGenerateValue,
            generateExcel,
          },
        })

        if (justGenerateValue)
          downloadBase64(
            document,
            result.completeFileName,
            result.report,
            atob(result.report)
          )
        // else showAlertSuccessTranslate('application.commons.sucess.operation');
      } catch (error) {
        console.log(error)
        if (isAxiosError(error)) {
          toast({
            title: 'Error',
            description: error.response?.data?.errorMessage ?? error.message,
            type: 'error',
          })
        } else {
          toast({
            title: 'Error',
            description: `${error}`,
            type: 'error',
          })
        }
      }
    }
  }

  const generate = async (
    justGenerate = false,
    optionGenerate = 'generateReport'
  ) => {
    try {
      setIsLoading(true)
      if (resultItemsSelected && !validaForm()) {
        toast({
          title: 'Error',
          description: t(
            'generateReport.dataToEditSection.mandatoryFieldsMessage'
          ),
          type: 'error',
        })
        return
      }

      if (user && user.userPosition) {
        const isCanGenerate = await canGenerate(optionGenerate, justGenerate)
        if (isCanGenerate && resultItemsSelected) {
          const documents = []
          const versions: string[] = []

          for (const itemDoc of resultItemsSelected) {
            if (itemDoc.id_document) {
              documents.push(itemDoc.id_document)
              if (!versions.includes(itemDoc.document_version))
                versions.push(itemDoc.document_version)
            }
          }

          if (documents && documents.length) {
            setShowConfirm(true)
            justSelectedGenerate = justGenerate
            setDescriptionDocuments(
              versions?.map((item) => `- ${item}.`).join('\n')
            )
          } else if (
            testSelected?.typeCode === 'corrosion' &&
            isDifferentHeader()
          ) {
            setDifferentHeaderModalOpen(true)
          } else if (testSelected?.id === 'microstructure_photos' || testSelected?.id === 'microstructure_photos_longitudinal') {
            await generateNewReport({
              justGenerateValue: justGenerate,
              generateExcel: false,
              user,
              site,
              remark1,
              remark2,
              remark3,
              customFields: {
                completeHeaderItem,
                customer: clientHeader,
                description: descriptionHeader,
                inspection: inspectionHeader,
                project: projectHeader,
                orderItem: pedidoItemHeader,
              },
            })
          } else {
            await generateReport(justGenerate, false)
          }
        }
      } else {
        toast({
          title: 'Error',
          description: t('user.not_position'),
          type: 'error',
        })
      }
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const exportAsExcelFile = () => {
    if (templateTest && resultItemsSelected && resultItemsSelected.length > 0) {
      const itensToExport = []
      for (const item of resultItemsSelected) {
        const newHeader: { [key: string]: any } = {}

        Object.entries(item).forEach(([key, value]) => {
          let newValue = value
          let newKey = key
          if (testSelected?.code === 'test.hardness') {
            if (
              key === 'dmeim' ||
              key === 'durezahv' ||
              key === 'durezahb' ||
              key === 'durezhrb' ||
              key === 'durezhrc' ||
              key === 'durhv10'
            ) {
              newKey = 'dmeim'
            }
          }
          if (testSelected?.code === 'test.nace.d' && key === 'id_ensaio') {
            newValue = `${value} - ${item.n_cp}`
          }
          if (testSelected?.code === 'test.chemical' && key === 'analysis') {
            newValue =
              value === 'AM_ANQC1'
                ? 'Check 1'
                : value === 'AM_ANQC2'
                  ? 'Check 1'
                  : ''
          }

          const field = templateTest.find((item) => item.id === newKey)?.header

          newHeader[field ? t(field) : t(key)] = value
        })

        itensToExport.push(newHeader)
      }

      // res.row = result.list.map((item: any, index: number) => {
      //   item['checked'] = item.document_version === undefined
      //   const objectRow = {...Object.entries(item).reduce((acc, [key, value]) => {
      //     if(value){
      //       let valueDiv = value;
      //       let newKey = key;
      //       if(testSelected.code === 'test.hardness'){
      //         if(key === 'dmeim' || key === 'durezahv' || key === 'durezahb' ||
      //             key === 'durezhrb' || key === 'durezhrc' || key === 'durhv10'){
      //           newKey = 'dmeim'
      //         }
      //       }
      //       if(testSelected.code === 'test.nace.d' && key === 'id_ensaio'){
      //         valueDiv = `${value} - ${item.n_cp}`
      //       }
      //       if(testSelected.code === 'test.chemical' && key === 'analysis'){
      //         valueDiv = value === 'AM_ANQC1' ? 'Check 1' :  value === 'AM_ANQC2' ? 'Check 1' : '';
      //       }
      //       acc[key] = <div style={{ whiteSpace: 'nowrap' }}>{String(valueDiv)}</div> as React.ReactNode;
      //     }
      //     return acc;
      //   }, {}), index};
      //   return objectRow;
      // })

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(itensToExport)
      const workbook: XLSX.WorkBook = {
        Sheets: { data: worksheet },
        SheetNames: ['data'],
      }
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'buffer',
      })
      const options: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' }
      XLSX.writeFile(workbook, 'list.xlsx', options)
    }
  }

  const confirm = async () => {
    try {
      setIsLoading(true)
      setShowConfirm(false)
      if (testSelected?.id === 'microstructure_photos' || testSelected?.id === 'microstructure_photos_longitudinal') {
        await generateNewReport({
          justGenerateValue: true,
          generateExcel: false,
          user,
          site,
          remark1,
          remark2,
          remark3,
          customFields: {
            completeHeaderItem,
            customer: clientHeader,
            description: descriptionHeader,
            inspection: inspectionHeader,
            project: projectHeader,
            orderItem: pedidoItemHeader,
          },
        })
      } else {
        await generateReport(true, false)
      }
    } catch (error) {
      console.log(error)
      if (isAxiosError(error)) {
        toast({ title: 'Error', description: error.message, type: 'error' })
      }
    } finally {
      setIsLoading(false)
    }
  }

  const onOutsideClickAlert = () => {
    setShowConfirm(false)
  }

  const validaForm = () => {
    return (
      clientHeader &&
      descriptionHeader &&
      inspectionHeader &&
      pedidoItemHeader &&
      (projectHeader || testSelected?.typeCode === 'collapse')
    )
  }

  const getDifferentHeader = () => {
    const differenceItemsHeader = []
    let edit = null

    if (resultItemsSelected) {
      for (const item of resultItemsSelected) {
        const test = {
          desc_cliente: item.desc_cliente,
          descricao_mes: item.descricao_mes,
          project: item.project,
          inspection: item.firma_insp,
          pedido: item.pedido,
          item: item.item,
        }
        if (!edit) {
          edit = test
          differenceItemsHeader.push(edit)
        }
        if (
          (edit.customer !== test.desc_cliente ||
            edit.description !== test.description ||
            edit.project !== test.project ||
            edit.inspection !== test.inspection ||
            (edit.pedido !== test.pedido && edit.item !== test.item)) &&
          findItem(test, differenceItemsHeader)
        ) {
          differenceItemsHeader.push(test)
        }
      }
    }
    return differenceItemsHeader
  }

  const generateDifferentHeader = async () => {
    try {
      setIsLoading(true)
      if (testSelected?.id === 'microstructure_photos' || testSelected?.id === 'microstructure_photos_longitudinal') {
        await generateNewReport({
          justGenerateValue: true,
          generateExcel: false,
          user,
          site,
          remark1,
          remark2,
          remark3,
          customFields: {
            completeHeaderItem,
            customer: clientHeader,
            description: descriptionHeader,
            inspection: inspectionHeader,
            project: projectHeader,
            orderItem: pedidoItemHeader,
          },
        })
      } else {
        await generateReport(true, false)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Section.Root
      header={
        <Section.Header
          title={t<string>(
            'generateReport.dataToEditSection.title',
            'Data to edit the document'
          )}
          isCollapsable
          actionButtons={
            <>
              <ButtonContainer width="8rem">
                <StyledButton onClick={() => generate(true)}>
                  <StyledTextButton>
                    <Icon name="DownloadLine2" color="white" />
                    {t<string>(
                      'generateReport.dataToEditSection.generate',
                      'Generate'
                    )}
                  </StyledTextButton>
                </StyledButton>
              </ButtonContainer>
              <ButtonContainer width="8rem">
                <StyledButton onClick={() => exportAsExcelFile()}>
                  <StyledTextButton>
                    <Icon name="FileExcel2Line" color="white" />
                    {t<string>('', 'Excel')}
                  </StyledTextButton>
                </StyledButton>
              </ButtonContainer>
            </>
          }
        />
      }
    >
      <StyledText>
        {' '}
        {t('generateReport.dataToEditSection.header', 'HEADER')}{' '}
      </StyledText>
      <Row>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>(
              'generateReport.dataToEditSection.client',
              'Client'
            )}{' '}
          </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setClientHeader(event?.target?.value)}
            placeholder={t(
              'generateReport.dataToEditSection.client',
              'Digite o Cliente'
            )}
            width="100%"
            value={clientHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>(
              'generateReport.dataToEditSection.description',
              'Description'
            )}{' '}
          </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setDescriptionHeader(event?.target?.value)}
            placeholder={t('', 'Digite a Descrição')}
            width="100%"
            value={descriptionHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>(
              'generateReport.dataToEditSection.inspection',
              'Inspection'
            )}{' '}
          </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setInspectionHeader(event?.target?.value)}
            placeholder={t('', 'Digite a Inspeção')}
            width="100%"
            value={inspectionHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>(
              'generateReport.dataToEditSection.orderItem',
              'Pedido/Item [PO]'
            )}{' '}
          </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setPedidoItemHeader(event?.target?.value)}
            placeholder={t('', 'Digite o Pedido/Item [PO]')}
            width="100%"
            value={pedidoItemHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>(
              'generateReport.dataToEditSection.project',
              'Project'
            )}{' '}
          </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setProjectHeader(event?.target?.value)}
            placeholder={t('', 'Digite o site')}
            width="100%"
            value={projectHeader}
          />
        </SearchBarContainer>
      </Row>
      <StyledText>
        {' '}
        {t('generateReport.dataToEditSection.remarks', 'REMARKS')}{' '}
      </StyledText>
      <Row>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>('generateReport.dataToEditSection.remark1')}{' '}
          </StyledInputLabel>
          <InputDropdown.Root
            onValueChange={(value) => setRemark1(value)}
            trigger={
              <InputDropdown.Trigger
                placeholder={t<string>(
                  'generateReport.dataToEditSection.select'
                )}
                style={{
                  width: '15rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  boxSizing: 'border-box',
                }}
              />
            }
            defaultValue={remark1}
          >
            {mapRemark1.map((value) => {
              return (
                <InputDropdown.Item
                  key={`SelectItem-${value}`}
                  value={value?.toString()}
                >
                  {value}
                </InputDropdown.Item>
              )
            })}
          </InputDropdown.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>('generateReport.dataToEditSection.remark2')}{' '}
          </StyledInputLabel>
          <InputDropdown.Root
            onValueChange={(value) => setRemark2(value)}
            trigger={
              <InputDropdown.Trigger
                placeholder={t<string>(
                  'generateReport.dataToEditSection.select'
                )}
                style={{
                  width: '15rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  boxSizing: 'border-box',
                }}
              />
            }
            defaultValue={remark2}
          >
            {mapRemark2.map((value) => {
              return (
                <InputDropdown.Item
                  key={`SelectItem-${value}`}
                  value={value?.toString()}
                >
                  {value}
                </InputDropdown.Item>
              )
            })}
          </InputDropdown.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>('generateReport.dataToEditSection.remark3')}{' '}
          </StyledInputLabel>
          <InputDropdown.Root
            onValueChange={(value) => setRemark3(value)}
            trigger={
              <InputDropdown.Trigger
                placeholder={t<string>(
                  'generateReport.dataToEditSection.select'
                )}
                style={{
                  width: '15rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  boxSizing: 'border-box',
                }}
              />
            }
            defaultValue={remark3}
          >
            {mapRemark3.map((value) => {
              return (
                <InputDropdown.Item
                  key={`SelectItem-${value}`}
                  value={value?.toString()}
                >
                  {value}
                </InputDropdown.Item>
              )
            })}
          </InputDropdown.Root>
        </SearchBarContainer>
      </Row>
      <DifferentHeaderModal
        isOpen={differentHeaderModalOpen}
        setIsOpen={setDifferentHeaderModalOpen}
        onOutsideClick={() => setDifferentHeaderModalOpen(false)}
        onConfirm={() => generateDifferentHeader()}
        textButtonConfirm={t<string>(
          'generateReport.dataToEditSection.generate',
          'Generate'
        )}
        items={getDifferentHeader()}
      />
      <AlertDialog
        open={showConfirm}
        variant="warn"
        title={`${t<string>('generateReport.dataToResult.hasDocuments')}`}
        description={descriptionDocuments}
        onOpenChange={onOutsideClickAlert}
        close={onOutsideClickAlert}
        footer={
          <ButtonsContainer>
            <StyledButton
              onClick={onOutsideClickAlert}
              key="cancel-button"
              variant="warnWithBorders"
            >
              <Text>{t<string>('application.button.cancel')}</Text>
            </StyledButton>
            <StyledButton
              onClick={confirm}
              key="confirm-button"
              variant="warnWithoutBorders"
            >
              <Text>{t<string>('application.button.confirm')}</Text>
            </StyledButton>
          </ButtonsContainer>
        }
      />
    </Section.Root>
  )
}

export default DataToEditSection
